import { render, staticRenderFns } from "./Portails.vue?vue&type=template&id=e65e98ce"
import script from "./Portails.vue?vue&type=script&lang=js"
export * from "./Portails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports